import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('widgetMasterStore', Object.keys(state)),
	...mapGetters('widgetMasterStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('widgetMasterStore', Object.keys(actions)),
	...mapMutations('widgetMasterStore', Object.keys(mutations))
};
